import React, { useCallback, useState } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import ConfirmationDialog from 'core/components/ConfirmationDialog';
import { getCommissionModelInfo, subscribeToCommissionModel } from 'services/operations/commissionModel';
import { useSnackbar } from 'notistack';

const CommissionModel = ({library}) => {

  const [openModal, setOpenModal] = useState(false);
  const [modalOptions, setModalOptions] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  function onCommissionModelCardClick() {
    const data={
      propertyId: library?.libraryId,
      propertyType: 'LIBRARY'
    }
    getCommissionModelInfo(data).then(({response, error}) => {
      if(response) {
        if(response?.subscribed){
          enqueueSnackbar("You have already activated commission model", {variant: 'success'});
        }else{
          loadConfirmModal(response)
        }
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function loadConfirmModal(response) {
    const data={
      title: 'Commission Model',
      confirmationText: 'Proceed',
      content: response?.description?.split('\n').join('<br/>')
    };
    setModalOptions(data);
    setOpenModal(true);
  }

  const onConfirm = useCallback(() => {
    const data={
      propertyId: library?.libraryId,
      propertyType: 'LIBRARY'
    }
    subscribeToCommissionModel(data).then(({response, error}) => {
      if(response){
        setOpenModal(false)
      }else{
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  },[enqueueSnackbar, library?.libraryId]);
  
  return (
    <>
      <Card sx={{ minWidth: 275, backgroundColor:'#f8f8f8', cursor:'pointer' }} onClick={onCommissionModelCardClick}>
        <CardContent>
          <Typography variant="h6" component="div">
            Commission Model
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Share a small commission on every booking you receive through Webook
          </Typography>
        </CardContent>
      </Card>
      <ConfirmationDialog  open={openModal} options={modalOptions} onCancel={() => setOpenModal(false)} onConfirm={onConfirm} />
    </>
  );
}
 
export default CommissionModel;
